import React from 'react';
import { TouchableOpacity, Text, StyleSheet, View, ViewStyle, TextStyle } from 'react-native';

type TTextIconBoxProps = {
  label: string;
  icon?: React.ReactNode;
  containerStyle?: ViewStyle;
  textStyle?: TextStyle;
};

export default function TextIconBox(props: TTextIconBoxProps) {
  const { label, icon, containerStyle, textStyle } = props;
  return (
    <View style={[styles.container, containerStyle]}>
      <Text style={[styles.label, textStyle]}>{label}</Text>
      {icon && <View style={styles.iconWrapper}>{icon}</View>}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#FDE68A', // Tailwind yellow-200
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 12,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 4,
    elevation: 3,
  },
  label: {
    fontSize: 20,
    fontWeight: '400',
    color: '#121212',
    fontFamily: 'Secular One',
  },
  iconWrapper: {
    marginLeft: 12,
  },
});
